import { createApp } from "vue";
import "typeface-poppins";
import "typeface-lato";
import App from "./App.vue";
import router from "./router";
import { store } from "./store/";
import "./registerServiceWorker";

const app = createApp(App);
app.use(router);
app.use(store);
app.mount("#app");
